import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/Group 1000002190.png";
import icon1 from "../Assets/social (1).png";
import icon2 from "../Assets/social (2).png";
import icon3 from "../Assets/social (3).png";
import icon4 from "../Assets/social (4).png";
import { ContactWithUs } from "../Common/apis";
import Loader from "../Loader/Loader";
import { toast } from "react-toastify";
import Aos from "aos";

function Contact() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
    agree: false
  });
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false
    }));
  };

  const handleSubmit = async () => {
    const { name, email, comment, agree } = formData;

    let newErrors = {};
    if (!name) newErrors.name = true;
    if (!email) newErrors.email = true;
    if (!comment) newErrors.comment = true;
    if (!agree) newErrors.agree = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // if (!name || !email || !comment) {
    //   toast.error("All fields are required!");
    //   return;
    // }

    // if (!agree) {
    //   toast.error("Please agree to the privacy policy!");
    //   return;
    // }

    setLoading(true);
    try {
      const res = await ContactWithUs({ name, email, comment });
      toast.success("Message sent successfully!");
      setFormData({ name: "", email: "", comment: "", agree: false });
    } catch (error) {
      toast.error("Something went wrong!");
    }
    setLoading(false);
  };
  return (
    <div className="main-div">
      <Navbar />
      <br />
      <br /> <br />
      <br />
      <div className="contact-div">
        <div className="contact-div-left">
          <div className="contact-form overflow-hidden">
            <h3 data-aos="fade-right">Leave Us Your Info.</h3>
            <br />
            <label>
              Your Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              data-aos="fade-left"
              placeholder="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={{ borderColor: errors.name ? "red" : "#ccc" }}
            />
            <br />
            <br />
            <label>
              Email Address <span style={{ color: "red" }}>*</span>
            </label>
            <input
              data-aos="fade-right"
              placeholder="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={{ borderColor: errors.email ? "red" : "#ccc" }}
            />
            <br />
            <br />
            <label>
              Comment <span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              data-aos="fade-left"
              placeholder="Comment"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              style={{ borderColor: errors.comment ? "red" : "#ccc" }}
            ></textarea>
            <br />
            <br />
            <div className="checkboc-div">
              <input
                type="checkbox"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
                style={{
                  outline: errors.agree ? "2px solid red" : "none",
                  boxShadow: errors.agree ? "0 0 0 4px red" : "none"
                }}
              />
              <p data-aos="fade-right">
                You agree to our friendly<span> privacy policy.</span>
                <span style={{ color: "red" }}>*</span>
              </p>
            </div>
            <br />

            <button data-aos="fade-left" onClick={handleSubmit} disabled={loading}>
              {loading ? <Loader /> : "Send Message"}
              <i className="bi bi-arrow-right-short"></i>
            </button>
          </div>

          <br />
          <br />
          {/* <div className="follow">
            <p>Follow Us :</p>
            <img src={icon1} />
            <img src={icon2} />
            <img src={icon3} />
            <img src={icon4} />
          </div> */}
        </div>
        <div className="contact-div-right">
          <div className="contact-box">
            <img data-aos="fade-right" src={img} />
            <h3 data-aos="fade-left">
              <i>Contact Us</i>
            </h3>
          </div>
          <br />
          <div className="contact-box2">
            <div className="icon-div">
              <div data-aos="fade-right" className="icon-i">
                <i className="bi bi-geo-alt"></i>
              </div>
              <div data-aos="fade-left">
                <h4>Address</h4>
                <p>
                  <a
                    href="https://maps.app.goo.gl/pVptsNMzLUkQm8Ew7"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}
                  >
                    Gisul
                    677, 27th Main Sector 1,
                    <br className="block md:hidden" />
                    HSR Layout, Bangalore
                    India
                    560102
                  </a>
                </p>
              </div>
            </div>
            <div className="icon-div">
              <div data-aos="fade-right" className="icon-i">
                <i className="bi bi-telephone"></i>
              </div>
              <div data-aos="fade-left">
                <h4>Contact Details</h4>
                <p>
                  <a href="tel:+918197982153" style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}>
                    +91 81979 82153
                  </a>
                </p>
                <p>
                  <a href="tel:+919036307082" style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}>
                    +91 90363 07082
                  </a>
                </p>
              </div>
            </div>
            <div className="icon-div">
              <div data-aos="fade-right" className="icon-i">
                <i className="bi bi-envelope"></i>
              </div>
              <div data-aos="fade-left">
                <h4>Email Us</h4>
                <p>
                  <a href="mailto:info@gisul.co.in" style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}>
                    info@gisul.co.in
                  </a>

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <Footer />
    </div>
  );
}

export default Contact;
